module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (207).e902a4a4.jpg";